import type { UseCase } from '@/core/shared'
import type { AccessConfigRepository } from '../domain'

export const removeAccessConfig: UseCase<AccessConfigRepository, 'removeAccessConfig'> = (repository) => {
  return async (accessConfigId) => {
    await repository.removeAccessConfig(accessConfigId)
  }
}
